module.exports = __webpack_public_path__ + "img/bi.073e30ba.svg";